
var user_switch = $('#userswitch_select');

if(user_switch.length !== 0) { //user switch is present on this page
  user_switch.change(function(event) { //on change, redirect to initiate login
    var target = $(event.currentTarget || event.target);
    if(target.data('changeUrl')) {
      window.location = target.data('changeUrl') + target.val();
    } else {
      bq.debug.error("no data-change-url detected on dom element", this);
    }
  });

  if(user_switch.data('ajaxUrl')) { //make sure ajaxUrl is available
                       
    user_switch.select2({
        minimumInputLength: 2,
        placeholder: 'Search',
        allowClear: true,        
        ajax: {
            url: user_switch.data('ajaxUrl'),
            dataType: 'json',
            data: function(term, page) {
                return {
                    search: term
                };
            },
            results: function (data, page) {
                return { results: data };
            }
        }
    });

  } else {
    bq.debug.error("no data-ajax-url detected on dom element", this);
  }

}